<template>
    <div class="card mb-4" style="border-radius: 12px; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
        <div class="card-header d-flex align-items-center" style="background-color: #F8FAFC; border-radius: 12px 12px 0 0;">
            <i class="fal fa-user-headset text-primary mr-2"></i>
            <h5 class="mb-0 font-weight-bold">Estado de conexión de agentes</h5>
        </div>
        <div class="card-body">
            <div class="row g-2">
                <div class="col-12 col-md-6">
                    <div
                        class="kpi-card kpi-card-success p-3 d-flex align-items-center justify-content-between"
                    >
                        <div class="d-flex align-items-center">
                            <i class="fal fa-user-check fa-2x mr-3"></i>
                            <div>
                                <p class="mb-0 kpi-label">AGENTES DISPONIBLES</p>
                                <p class="mb-0 kpi-value">
                                    {{ availableCount }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div
                        class="kpi-card kpi-card-danger p-3 d-flex align-items-center justify-content-between"
                    >
                        <div class="d-flex align-items-center">
                            <i class="fal fa-user-slash fa-2x mr-3"></i>
                            <div>
                                <p class="mb-0 kpi-label">AGENTES DESCONECTADOS</p>
                                <p class="mb-0 kpi-value">
                                    {{ disconnectedCount }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RealTimeAgentStatus",
    data() {
        return {
            status: {
                disponibles: 0,
                desconectados: 0,
                conectados: 0,
                total: 0,
            },
            timer: null,
        };
    },
    computed: {
        // Si el backend no puede determinar 'disponibles' por estado 'DISP', usamos 'conectados'
        availableCount() {
            const disp = Number(this.status.disponibles || 0);
            const con = Number(this.status.conectados || 0);
            return disp > 0 ? disp : con;
        },
        disconnectedCount() {
            const total = Number(this.status.total || 0);
            const connected = Number(this.status.conectados || 0);
            return Math.max(0, total - connected);
        },
    },
    mounted() {
        this.fetchStatus();
        // refresco periódico (sin Pusher)
        this.timer = setInterval(this.fetchStatus, 15000); // 15s
    },
    beforeDestroy() {
        if (this.timer) clearInterval(this.timer);
    },
    methods: {
        async fetchStatus() {
            try {
                const res = await fetch(
                    "/admin/dashboard-solicitudes/agent-status"
                );
                const json = await res.json();
                if (json.success) {
                    this.status = json.data;
                }
            } catch (e) {
                // silencio errores de red para no molestar al usuario
            }
        },
    },
};
</script>

<style scoped>
.kpi-card {
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.mr-3 {
    margin-right: 12px;
}
.kpi-value {
    font-size: 2rem;
    font-weight: bold;
}
.kpi-label {
    font-size: 0.9rem;
    opacity: 0.9;
}
.kpi-card-success {
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    color: #fff;
}
.kpi-card-danger {
    background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
    color: #fff;
}
</style>
